
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic05On as ObiHydraulic05OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-05-on.js';
 
 
 

 
 export const ObiHydraulic05On = createComponent({
   react: React,
   tagName: 'obi-hydraulic-05-on',
   elementClass: ObiHydraulic05OnElement,
   events: {
     
   }
  });
 
 